import "./lib/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { AppRouter } from "./router/AppRouter";
import "./index.css";

// Auto-reload when a new service worker takes control
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Noe gikk galt. Vennligst last siden på nytt.</p>}>
      <AppRouter />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
